import { Link, useLoaderData } from 'react-router'
import { LivestreamGrid } from '#app/components/livestream-grid.tsx'
import { getLivestreamHistory, getLivestreamStats } from '#app/utils/livestream.server.ts'
import { type Route } from './+types/livestreams.ts'

export const meta = () => {
	return [
		{ title: 'JaseOwns - Livestreams' },
		{ name: 'description', content: 'Browse all past livestreams from JaseOwns on YouTube and Twitch.' },
	]
}

export async function loader({ request }: Route.LoaderArgs) {
	const url = new URL(request.url)
	const searchQuery = url.searchParams.get('q') || ''

	const livestreams = await getLivestreamHistory({ limit: 50, search: searchQuery })
	const livestreamStats = await getLivestreamStats()

	return { livestreams, livestreamStats, searchQuery }
}

export default function Livestreams() {
	const { livestreams, livestreamStats, searchQuery } = useLoaderData<typeof loader>()

	return (
		<main className="container mx-auto text-black dark:text-white">
			<h1 className="text-3xl px-10 mb-6 text-cyan-900 dark:text-cyan-200 flex flex-row items-center gap-2">
				<img src="/images/youtube.png" alt="YouTube" className="w-10 h-10" /> Livestreams
			</h1>
			<div className="flex flex-col px-10 mb-6">
				<LivestreamGrid
					livestreams={livestreams}
					livestreamStats={livestreamStats}
					searchQuery={searchQuery}
				/>
			</div>
			<div className="px-10 mb-6">
				<Link to="/schedule" className="text-sm text-cyan-600 dark:text-cyan-400 hover:underline">&larr; Back to Schedule</Link>
			</div>
		</main>
	)
}
